export default __webpack_public_path__ + "static/media/iab-funnel-first-order.73ebbb4d.svg";